import i18next from 'i18next';

const optionsSelector = (options: any[]) => {
  return options;
};

export default optionsSelector;
